var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehanceIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.05 14.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #030e1f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.3,6.68s2.18-.17,2.18-2.78S10.01.01,7.75.01H0s0,14.4,0,14.4h7.93s3.96.13,3.96-4.32c0,0,.29-3.41-2.58-3.41ZM2.88,2.16h3.96s1.36.02,1.36,1.78-1.36,1.82-1.36,1.82h-3.96v-3.6ZM7.2,12.25H2.88v-4.32h4.32s2.16.02,2.16,2.16-1.85,2.16-2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.01,3.6c-5.41,0-5.4,5.4-5.4,5.4,0,0-.36,5.4,5.4,5.4,0,0,5.04,0,5.04-4.32h-2.88s0,2.16-2.16,2.16c0,0-2.16,0-2.16-2.88h7.2c0-1.44,0-5.76-5.04-5.76ZM15.85,7.93s-.05-2.16,2.16-2.16,2.16,2.16,2.16,2.16h-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.89,1.44h-5.76v1.44h5.76v-1.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceIcn);
export default __webpack_public_path__ + "static/media/behance-icn.4807e4d661677c15c172e888e9d8ee31.svg";
export { ForwardRef as ReactComponent };